var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeclarationsListLayout',_vm._l(([0, 1, 2]),function(int){return _c('DeclarationsListLoadingItem',{key:int})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }